import { commitMutation, Environment, graphql } from 'react-relay';
import { Disposable, MutationConfig } from 'relay-runtime';

import { DeleteTeamTypeMutation } from './__generated__/DeleteTeamTypeMutation.graphql';

interface DeleteTeamTypeInput {
	id: string;
}

export const deleteTeamTypeMutation = (
	environment: Environment,
	input: DeleteTeamTypeInput,
	events: Pick<MutationConfig<DeleteTeamTypeMutation>, 'onCompleted' | 'onError'>,
): Disposable => {
	return commitMutation<DeleteTeamTypeMutation>(environment, {
		mutation: graphql`
			mutation DeleteTeamTypeMutation($id: ID!) {
				team {
					deleteTeamType(id: $id) @optIn(to: "Team-types") {
						id
						state
					}
				}
			}
		`,
		variables: {
			id: input.id,
		},
		updater: (store, data) => {
			const deletedTeamType = data?.team?.deleteTeamType;
			if (!deletedTeamType) {
				return;
			}

			const teamTypeRecord = store.get(deletedTeamType.id);
			if (teamTypeRecord) {
				teamTypeRecord.setValue(deletedTeamType.state, 'state');
			}
		},
		onCompleted: events.onCompleted,
		onError: events.onError,
	});
};
